import { isRouteErrorResponse, useRouteError } from 'react-router'

/**
 * Module-level error boundary.
 *
 * Mounted as `errorElement` on each module route rather than once at the root, so a
 * screen that throws takes down its own outlet and leaves the shell — sidebar, frame,
 * client selector — standing and navigable.
 *
 * It logs. An error state that swallows the cause is worse than the crash, because
 * the crash at least tells you where to look.
 */
export function ErrorBoundary() {
  const erro = useRouteError()

  console.error('[erro de rota]', erro)

  const detalhe = isRouteErrorResponse(erro)
    ? `${erro.status} ${erro.statusText}`
    : erro instanceof Error
      ? erro.message
      : 'erro desconhecido'

  return (
    <section
      role="alert"
      className="border-danger-100 bg-danger-100 rounded-card flex max-w-2xl flex-col gap-3 border p-7"
    >
      <h2 className="type-h4 text-danger-700">Esta tela falhou ao carregar</h2>
      <p className="type-body text-text-body">
        O restante da plataforma continua funcionando — use a navegação para sair daqui.
      </p>
      <code className="rounded-field bg-surface-card text-text-muted overflow-x-auto px-4 py-3 type-sm">
        {detalhe}
      </code>
    </section>
  )
}
